<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
          <!-- <AppAddButton v-bind:permission="permission">
          <a v-bind:href="helper.WEB_URL + '/productForm'" ref="createNewCarParkProductButton" class="btn btn-rounded btn-block-xs-only" style="background: #85C92F; color: #fff;">
            Create New Car Park Product
          </a>
          </AppAddButton> -->
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="onSearchChange" />
        
      </div>

      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" />

      <AppFilter 
        ref="zoneFilter" 
        filterKey="zoneID"
        v-show="zoneFilterVisible"
        v-bind:filterEmptyMessage="'No car park zone data available'"
        v-on:filter-data-change="onFilterZoneChange" />
      
      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-cell-click="onTableCellClick"
        v-on:table-page-change="onTablePageChange" />
      
      <AppTable 
        ref="pageBay" 
        v-bind:tableParameter="BAY_PARAM" 
        v-bind:permission="permission" />

      <TemplateFeedback ref="pageFeedback" />

      <TemplateModal
        v-bind:modalId="'jt-product-active-confirm-modal'">
        <h4 slot="modal-title" class="modal-title" >
          Activate Product Fees
        </h4>
        <div slot="modal-body">
          Are you sure you want to set this product fees to Active?
        </div>
        <div slot="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
          <button @click="onActiveConfirmClick" type="button" class="btn btn-danger">
            Confirm
          </button>
        </div>
      </TemplateModal>
      
      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PARAM" 
        v-bind:permission="permission"
        v-on:modal-data-add="onModalAddDataClick"
        v-on:modal-data-edit="onModalEditDataClick"
        v-on:modal-data-delete="onModalDeleteDataClick" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import TemplateModal from "@/components/Template/TemplateModal";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const BAY_PARAM = [
  {
    key: 'type',
    text: 'Bay Type',
  },
  {
    key: 'allocation',
    text: 'Allocation (A)',
  },
  {
    key: 'oversell',
    text: 'Oversell (B)',
  },
  {
    key: 'used',
    text: 'Used (C)',
  },
  {
    key: 'entitlement',
    text: 'Entitlement (D)',
  },
  {
    key: 'entitlementUsed',
    text: 'Entitlement Used (E)',
  },
  {
    key: 'remain',
    text: '(A+B-C-D) Remain',
  },
];

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'carparkID',
    text: 'Car Park',
    table_hide: true,
    form_select: [],
    form_chosen: true,
    form_add_input_attr: {
      disabled: true,
    },
    form_edit_hide: true,
    form_edit_input_attr: {
      disabled: true,
    },
    form_edit_validation: [],
  },
  {
    key: '_carparkName',
    text: 'Car Park',
    form_hide: true,
    form_input_validation: [],
  },
  {
    key: 'zoneID',
    text: 'Zone',
    table_hide: true,
    form_select: [],
    form_chosen: true,
    form_add_input_attr: {
      disabled: true,
    },
    form_edit_input_attr: {
      disabled: true,
    }
  },
  {
    key: '_zoneName',
    text: 'Zone',
    form_hide: true,
    form_input_validation: [],
  },
  {
    key: 'name',
    text: 'Product Name',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a href="${helper.WEB_URL}/productForm?productID=${dataItem.id}&carparkID=${dataItem.carparkID}&zoneID=${dataItem.zoneID}">${dataItem.name}</a>`;
    },
  },
  // {
  //   key: 'image',
  //   text: 'Image',
  //   form_dropzone: true,
  // },
  {
    key: 'isTenant',
    text: 'Tenant Type',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return dataItem[parameterItem.key] ? 'T' : 'NT';
    },
  },
  {
    key: 'bayType',
    text: 'Bay Type',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      let bayType = parseInt(dataItem[parameterItem.key]);
      switch(bayType) {
				case 1:
				  return 'NR';
				case 2:
				  return 'R';
				case 3:
				  return 'TR';
				case 4:
				  return 'M';
      }
      return dataItem[parameterItem.key];
    },
    form_edit_input_attr: {
      disabled: true,
    }
  },
  {
    key: 'activeNow',
    text: 'Active Now',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      
      let fees = dataItem['activeFees'];

      if(!fees) {
        return '-'
      }

      let text = ''
      text += 'Start Date: ' + helper.parseDateTime(fees['startDate']).format('YYYY-MM-DD') + '</br>'
      text += 'Deposit: ' + helper.formatMoney(fees['deposit']) + '</br>'
      text += 'Establishment Fees: ' + helper.formatMoney(fees['establishment']) + '</br>'
      text += 'Monthly: ' + helper.formatMoney(fees['monthly']) + '</br>'
      text += 'Quarterly: ' + helper.formatMoney(fees['quarterly']) + '</br>'
      text += 'Half-Yearly: ' + helper.formatMoney(fees['halfYearly']) + '</br>'
      text += 'Yearly: ' + helper.formatMoney(fees['annually']) + '</br>'

      return text;
    },
  },
  {
    key: 'activeToday',
    text: 'Active Today or Past',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      
      let fees = dataItem['activeToday'];

      if(!fees) {
        return '-'
      }

      let text = ''
      text += 'Start Date: ' + helper.parseDateTime(fees['startDate']).format('YYYY-MM-DD') + '</br>'
      text += 'Deposit: ' + helper.formatMoney(fees['deposit']) + '</br>'
      text += 'Establishment Fees: ' + helper.formatMoney(fees['establishment']) + '</br>'
      text += 'Monthly: ' + helper.formatMoney(fees['monthly']) + '</br>'
      text += 'Quarterly: ' + helper.formatMoney(fees['quarterly']) + '</br>'
      text += 'Half-Yearly: ' + helper.formatMoney(fees['halfYearly']) + '</br>'
      text += 'Yearly: ' + helper.formatMoney(fees['annually']) + '</br>'

      return text;
    },
  },
  {
    key: 'Activate',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];

      let fees = dataItem['activeToday'];
      if(!fees) {
        return ''
      }

      return '<a href="#" onclick="event.preventDefault();">Activate</a>';
    },
  },
  {
    key: 'isEnable',
    text: 'Is Enable',
    table_custom: helper.tableCustomEnableDisable,
  },
  {
    key: 'isPublic',
    text: 'Is Public',
    table_custom: helper.tableCustomYesNo,
  },
  {
    key: 'fees',
    text: 'Fees',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a href="${helper.WEB_URL}/productFees?productID=${dataItem.id}">Fees</a>`;
    },
    form_input_validation: [],
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageProductFeesManual",
  components: {
    TemplateBasic,
    TemplateButton,
    TemplateModal,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      helper: helper,
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Car Park', url: '/carpark' },
        { name: 'Product' },
      ],

      PARAM,
      PARAM_MAP,
      BAY_PARAM,

      zoneFilterVisible: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    if(!helper.hasViewPermission('productfee')) {
      this.PARAM_MAP['fees'].table_hide = true;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.loadCarpark();
  },
  methods: {
    loadCarpark() {
      this.$refs['pageTable'].setTableData(null);
      this.$refs['carparkFilter'].setFilterLoading('Loading car park data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, response.data), this.$route.query.carparkID);
          helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], response.data);

          if(response.data && response.data.length > 0) {
            this.onFilterCarparkChange();
          }
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    loadZone() {
      this.$refs['pageTable'].setTableData(null);
      this.$refs['zoneFilter'].setFilterLoading('Loading zone data...');

      let url = helper.SERVER_URL + '/api2/zone';
      let carparkFilter = this.$refs['carparkFilter'].filterValue;
      if(carparkFilter) {
        url = helper.SERVER_URL + `/api2/carpark/${carparkFilter}/zone`;
      }

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['zoneFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Zones'}, response.data), this.$route.query.zoneID);
          helper.inputSelectSetOption(this.PARAM_MAP['zoneID'], response.data);

          if(response.data && response.data.length > 0) {
            this.onFilterZoneChange();
          }
        })
        .catch(error => {
          this.$refs['zoneFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'zone data'));
        });
    },
    loadData() {
      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$refs['pageTable'].setTableData();
      this.$refs['pageBay'].setTableData();

      let url = this.getUrl(this.$refs['carparkFilter'].filterValue, this.$refs['zoneFilter'].filterValue);
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          response.data.forEach(k => {
            k['_zone'] = this.$refs['zoneFilter'].filterData.find(j => String(j.id) === String(k.zoneID));
            if(k['_zone']) {
              k['_zoneName'] = k['_zone'].name;
              k['carparkID'] = k['_zone'].carparkID;
              k['_carpark'] = this.$refs['carparkFilter'].filterData.find(j => j.id === k['carparkID']);
              k['_carparkName'] = k['_carpark'] ? k['_carpark'].name : '';
            }
          })
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageProduct = response.data;
          this.loadFee();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'product data'));
        })
    },
    async loadFee() {
      let feedbackItem = 'product fee data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$refs['pageTable'].setTableData();
      this.$refs['pageBay'].setTableData();

      let today = moment().startOf('day')

      for(let product of this.pageProduct) {
        let url = helper.SERVER_URL + '/api2/season/' + product['id'] + '/seasonFees/';

        let result = await this.$http
          .get(
            url,
            helper.createAxiosConfig()
          )
          .then(response => {
            let resultMeta = helper.processAxiosResponse(this, response, false);

            for(let fees of response.data) {
              if(fees.isActive) {
                product.activeFees = fees
              } else if (!fees.isPast && fees.startDate <= today.unix()) {
                product.activeToday = fees
              }
            }

            return true
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'product fees data'));
          })

        if(!result) {
          return
        }
      }

      this.$refs['pageTable'].setTableData(this.pageProduct, this.$refs['pageTable'].getCurrentPage());
      this.$refs['pageFeedback'].setFeedbackMessage();
    },
    loadBay() {
      let feedbackItem = 'bay data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$refs['pageTable'].setTableData();
      this.$refs['pageBay'].setTableData();

      let url = helper.SERVER_URL + '/api2';
      url += '/bay/?1=1';
      let carparkFilter = this.$refs['carparkFilter'].filterValue;
      if(carparkFilter) {
        url += '&carparkID=' + carparkFilter;
        let zoneFilter = this.$refs['zoneFilter'].filterValue;
        if(zoneFilter) {
          url += '&zoneID=' + zoneFilter;
        }
      }
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, false);

          let tempBay2 = {};
          response.data.forEach(k => {
            if(!k.seasonID) {
              return;
            }
            
            let temp = tempBay2[k.seasonID];
            if(!temp) {
              let season = this.pageProduct.find(j => j.id === k.seasonID);
              temp = tempBay2[k.seasonID] = tempBay2[k.seasonID] || {
                // 'carpark' : season.carpark,
                // 'zone': season.zone,
                // 'season': season.name,
                // 'tenantType': season.tenantType,
                // 'bayType': k.bayType,
                'allocation': 0,
                'used': 0,
                'entitle': 0,
              };
            }

            temp['allocation']++;
            if(k.leaseID) {
              temp['used']++;
            }
            if(k.customerID) {
              temp['entitle']++;
            }
          });
          this.pageProduct.forEach(k => {
            let bayInfo = tempBay2[k.id] || {};
            k['bayAllocation'] = bayInfo['allocation'] || 0;
            k['bayUsed'] = bayInfo['used'] || 0;
            k['bayAvailable'] = k['bayAllocation'] - k['bayUsed'];
          });
          this.$refs['pageTable'].setTableData(this.pageProduct, this.$refs['pageTable'].getCurrentPage());
          
          let bayTypeConst = ['Reserved', 'Tandem-Reserved', 'Non-Reserved', 'Motorcycle', 'Visitor'];
          let tempBay = {};
          for(let string of bayTypeConst) {
            tempBay[string] = {
              'type': string,
              'allocation': 0,
              'oversell': 0,
              'used': 0,
              'entitlement': 0,
              'entitlementUsed': 0,
              'remain': 0
            };
          }
          response.data.forEach(k => {
            if(k.bayType === 'NA') {
              return;
            }

            let temp = tempBay[k.bayType];

            temp['allocation']++;
            if(k.seasonID) {
              let season = this.pageProduct.find(j => j.id === k.seasonID) || {};
              if(!season.entitleOnly) {
                temp['used']++;
              } else {
                temp['entitlement']++;
              }
            }
            if(k.customerID) {
              temp['entitlementUsed']++;
            }
            temp['remain'] = temp['allocation'] + temp['oversell'] - temp['used'] - temp['entitlement'];
          });
          this.finalBay = Object.values(tempBay);
          this.$refs['pageBay'].setTableData(this.finalBay);

          this.$refs['pageFeedback'].setFeedbackMessage();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'product data'));
        })
    },

    getUrl(carparkID, zoneID) {
      let url = helper.SERVER_URL + '/api2';
      if(zoneID) {
        let zone = this.$refs['zoneFilter'].filterData.find(k => helper.compareID(k.id, zoneID))
        url += '/carpark/' + zone.carparkID;
        url += '/zone/' + zoneID;
      } else if(carparkID) {
        url += '/carpark/' + carparkID;
      }
      url += '/season/';

      return url;
    },

    onTablePageChange() {
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },
    onFilterCarparkChange() {
      this.$refs['pageTable'].setCurrentPage(1);
      
      // if(this.$refs['carparkFilter'].filterValue) {
      //   this.zoneFilterVisible = true;
      //   this.loadZone();
      // } else {
      //   this.zoneFilterVisible = false;
      //   this.loadData();
      // }

      this.zoneFilterVisible = true;
      this.loadZone();
    },
    onFilterZoneChange() {
      this.$refs['pageTable'].setCurrentPage(1);
      
      this.loadData();
    },

    onAddButtonClick() {
      this.$refs['pageFeedback'].setFeedbackMessage();
      
      let defaultData = this.$refs['pageModal'].$refs['modalForm'].getFormDefaultData();
      defaultData['carparkID'] = this.$refs['carparkFilter'].filterValue;
      defaultData['zoneID'] = this.$refs['zoneFilter'].filterValue;
      
      helper.redirect({ path: helper.WEB_URL + '/productForm', query: { carparkID: this.$refs['carparkFilter'].filterValue, zoneID: this.$refs['zoneFilter'].filterValue }});
    },
    onTableDataClick(tableData, tableDataIndex) {
      this.$refs['pageFeedback'].setFeedbackMessage();
      helper.redirect({ path: helper.WEB_URL + '/productForm', query: { productID: tableData[tableDataIndex].id }});
    },
    onTableCellClick(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      if(tableParameter[tableParameterIndex]['key'] === 'Activate') {
        this.selectedProduct = tableData[tableDataIndex];
        $('#jt-product-active-confirm-modal').modal('show');
      }
    },
    async onActiveConfirmClick() {
      $('#jt-product-active-confirm-modal').modal('hide');

      if(this.selectedProduct.activeFees && this.selectedProduct.activeToday) {
        this.$refs['pageModal'].setModalLoading('Deactivating current parking fees');
        if(await this.$http
          .post(
            helper.SERVER_URL + '/api2/season/' + this.selectedProduct.id + '/seasonFees/' + this.selectedProduct.activeFees.id + '/deactivate',
            '',
            helper.createAxiosFormConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            this.$refs['pageModal'].setModalMessage('Succesfully deactivate current parking fees');
          })
          .catch(error => {
            this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'deactivating', 'parking fees'));
            return true;
          })) {
            this.$refs['pageModal'].setModalMessage('Problem deactivate current parking fees');
            return;
          }
      }

      this.$refs['pageModal'].setModalLoading('Setting parking fees to active');
      this.$http
        .post(
          helper.SERVER_URL + '/api2/season/' + this.selectedProduct.id + '/seasonFees/' + this.selectedProduct.activeToday.id + '/activate',
          '',
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageModal'].setModalClose();
          this.$refs['pageFeedback'].setFeedbackMessage('Succesfully set parking fees to active');
          this.loadData();
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'setting', 'parking fees to active'));
        })
    },

    onModalAddDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Adding ' + selectedData.name);
      
      this.$http
        .post(
          this.getUrl(selectedData.carparkID, selectedData.zoneID),
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['carparkFilter'].setFilterValue(selectedData.carparkID);
          this.$refs['zoneFilter'].setFilterValue(selectedData.zoneID);
          this.upsertDataComplete('Successfully added ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding', 'data'));
        })
    },
    onModalEditDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Updating ' + selectedData.name);

      this.$http
        .put(
          this.getUrl(selectedData.carparkID, selectedData.zoneID) + selectedData.id,
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'updating', 'data'));
        })
    },
    onModalDeleteDataClick(selectedData) {
    },
    upsertDataComplete(message) {
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/CarPark/PageProductFeesChange.vue